import script from "./BasePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasePage.vue?vue&type=script&lang=ts&setup=true"

import "./BasePage.vue?vue&type=style&index=0&id=598b105f&lang=scss"

const __exports__ = script;

export default __exports__